/**
 * OfertaBackdrop — спокойный «editorial» фон для оферты.
 *
 * Отличается от OnboardingBackdrop меньшей яркостью и медленной
 * динамикой — нужна атмосфера «серьёзного документа», а не
 * «запуска». Три слоя:
 *   1. Глубокая чёрно-синяя подложка
 *   2. Тонкая лунная дуга сверху (статика, subtle glow)
 *   3. Zrn-шумовой слой 3% soft-light
 */
const NOISE_SVG = encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' width='140' height='140'>
    <filter id='n'><feTurbulence type='fractalNoise' baseFrequency='1.1' numOctaves='2' stitchTiles='stitch'/></filter>
    <rect width='100%' height='100%' filter='url(#n)' opacity='1'/>
  </svg>`,
);

export function OfertaBackdrop() {
  return (
    <>
      {/* Deep editorial base */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(140% 100% at 50% -10%, rgba(22,24,42,1) 0%, rgba(10,12,22,1) 55%, rgba(4,5,10,1) 100%)',
        }}
      />

      {/* Soft lunar halo from top */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(60% 30% at 50% 0%, rgba(245, 217, 126, 0.10) 0%, rgba(245, 217, 126, 0) 70%)',
        }}
      />

      {/* Faint cosmic sweep */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'conic-gradient(from 210deg at 50% 50%, rgba(60,170,200,0.05) 0deg, rgba(140,100,220,0.03) 120deg, rgba(90,120,200,0.05) 240deg, rgba(60,170,200,0.05) 360deg)',
          filter: 'blur(120px)',
        }}
      />

      {/* Noise */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml;utf8,${NOISE_SVG}")`,
          backgroundSize: '140px 140px',
          opacity: 0.03,
          mixBlendMode: 'soft-light',
        }}
      />

      {/* Vignette */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(120% 80% at 50% 50%, transparent 40%, rgba(0,0,0,0.6) 100%)',
        }}
      />
    </>
  );
}
